import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const imvFollowUpLetterApi = createApi({
  baseQuery,
  reducerPath: 'imvFollowUpLetterApi',
  endpoints: builder => ({
    getimvFollowUpLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, monitoring_visit_id }) => ({
        url: `${formatString(
          endPoints.ImvFollowUp.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&monitoring_visit_id=${monitoring_visit_id}&application_section=CONDUCT&application_module_section=STUDY LOGS
            `,
        method: 'GET'
      })
    }),

    createImvFollowUpData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.ImvFollowUp.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      })
    }),

    updateImvFollowUpData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.ImvFollowUp.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      })
    }),
    getAllImvFollowUpData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => {
        return {
          url: `${formatString(endPoints.ImvFollowUp.getAll)}?${study_id !== null ? `study_id=${study_id}` : ''}${
            country !== null ? `&country=${country}` : ''
          }${
            site_id !== null ? `&site_id=${site_id}` : ''
          }&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
          method: 'GET'
        };
      }
    }),
    getPublishImvFollowUpData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => {
        return {
          url: `${formatString(endPoints.ImvFollowUp.getPublish)}?${study_id !== null ? `study_id=${study_id}` : ''}${
            country !== null ? `&country=${country}` : ''
          }${
            site_id !== null ? `&site_id=${site_id}` : ''
          }&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
          method: 'GET'
        };
      }
    }),

    publishImvFollowUpData: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        data,
        publish_doc_version,
        monitoring_visit_id,
        update,
        application,
        is_published,
        time_zone_id
      }) => ({
        url: `${formatString(
          endPoints.ImvFollowUp.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&publish_doc_version=${publish_doc_version}&monitoring_visit_id=${monitoring_visit_id}&update=${update}&is_published=${is_published}&time_zone_id=${time_zone_id}&application=${application}&application_section=CONDUCT&application_module_section=STUDY LOGS`,
        method: 'POST',
        body: data
      })
    })
  })
});

export const {
  useLazyGetimvFollowUpLetterQuery,
  useLazyGetAllImvFollowUpDataQuery,
  useCreateImvFollowUpDataMutation,
  useUpdateImvFollowUpDataMutation,
  usePublishImvFollowUpDataMutation,
  useLazyGetPublishImvFollowUpDataQuery
} = imvFollowUpLetterApi;
